import './about.scss';

export default function About() {
  return (
    <div className="About" id="about">
      <div className="left">
        <div className="wrapper">
          <h1>Who am I?</h1>

          <p className="desc">
            Hello! I'm Adeel, a Software Engineer based in{' '}
            <b>Karachi, Pakistan</b> who's experienced in taking fullstack
            applications from scratch to production.
            <br />
            <br />
            I'm graduated with a degree in Sotfware Engineering and working as a{' '}
            <b>Software Engineer</b> at <b>Koderlabs</b>.
          </p>
        </div>
      </div>
      <div className="right">
        <img src="assets/Adeel.jpeg" alt="" />
      </div>
    </div>
  );
}
